module.exports = __webpack_public_path__ + "img/number_bg@3x.3bcfad8d.png";